/**
 * @fileoverview Constantes del Centro de Ayuda: íconos del bucket público help-center-bucket
 * y valores que viajan al servicio de tracking.
 * @module constants/help-center
 */

const ICONS_BASE_URL = 'https://storage.googleapis.com/help-center-bucket/icons'

/**
 * Íconos del Centro de Ayuda. Viven en un bucket externo: no se empaquetan con la app.
 */
export const ICONS = Object.freeze({
  SEARCH: `${ICONS_BASE_URL}/icon_searching_lupa.svg`,
  BACK: `${ICONS_BASE_URL}/icon_searching_back.svg`,
  NO_RESULTS: `${ICONS_BASE_URL}/icon_searching_info.svg`,
  PLUS: `${ICONS_BASE_URL}/plus.svg`,
  MINUS: `${ICONS_BASE_URL}/minus.svg`,
  ARROW: `${ICONS_BASE_URL}/arrow_left.svg`,
  ARROW_WHITE: `${ICONS_BASE_URL}/arrow_left_white.svg`
})

/**
 * Acciones que el Centro de Ayuda registra en el servicio de tracking.
 */
export const TRACKING_ACTIONS = Object.freeze({
  SEARCH: 'search',
  CLICK_TOPIC: 'click topic',
  CLICK_QUESTION: 'click question',
  CLICK_LINKS: 'click links'
})

/**
 * Módulo con el que se registra la búsqueda (sin tilde: así lo espera el servicio de tracking).
 */
export const TRACKING_MODULE_SEARCH = 'Busqueda'

/**
 * Origen del tracking de búsqueda cuando el usuario tiene más de un producto.
 */
export const TRACKING_ORIGIN_MULTIPLE = 'varios'



// WEBPACK FOOTER //
// ./src/constants/help-center.js